import React from "react";
import { Box, Flex, Icon, Stack, Text } from "@chakra-ui/react";
import { MdCached } from "react-icons/md";
import StatusChipIndicator from "./StatusChipIndicator";
import { useSectionColors } from "./statusCardStyles";

/**
 * Displays Redis cache connection status and cached keys count.
 * @param {object} props
 * @param {object|null} props.redis - Redis status data from API
 * @returns {React.ReactElement}
 */
function RedisCacheSection({ redis }) {
    const { boxBg, label, value, title } = useSectionColors();
    return (
        <Box>
            <Flex align="center" gap="8px" mb="12px">
                <Icon as={MdCached} w="20px" h="20px" color="orange.500" />
                <Text fontSize="md" fontWeight="600" color={title}>Redis Cache</Text>
            </Flex>
            <Box p="14px" bg={boxBg} borderRadius="12px">
                <Stack spacing="10px">
                    <Flex justify="space-between" align="center">
                        <Text fontSize="sm" color={label}>Connection</Text>
                        <StatusChipIndicator isActive={redis?.connected} activeLabel="Active" inactiveLabel="Inactive" />
                    </Flex>
                    <Flex justify="space-between" align="center">
                        <Text fontSize="sm" color={label}>Cached keys</Text>
                        <Text fontSize="lg" fontWeight="700" color={value}>{redis?.cache_keys_count || 0}</Text>
                    </Flex>
                </Stack>
            </Box>
        </Box>
    );
}

export default RedisCacheSection;
